import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

export enum Type {
  Date = 'date',
  Range = 'range',
  Multirange = 'multirange',
}
// Needs to be before namespace is defined
const TYPES: ReadonlySet<Type> = new Set(Object.values(Type) as Type[])
export namespace Type {
  export const ALL: readonly Type[] = Array.from(TYPES)
  export const isType =
    TypeChecker.Factory.oneOf(TYPES).usingAlias('Instance.Type')
  export const assertIsType: TypeAsserter<Type> =
    TypeAsserter.Factory.from(isType)
}
